// extracted by mini-css-extract-plugin
module.exports = {"orgLogo":"_2eBbjpFq","orgTitleLink":"_1oyWwG8s","basicInfoContainer":"_3SCloJLN","basicInfoColumnInputs":"_2Rq5yO5T","mainSubtitle":"KXbUfsGi","educationName":"_2V3oVDxj","degree":"_1PHX-Hgo","years":"_2ZWfJ1Z_","gpa":"_314qOE_F","movedContainer":"yc34mG1x","addButtonBorder":"_3NzCX4ei"};
    if(module.hot) {
      // 1746735792165
      var cssReload = require("!../../../../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  